import { types as productsTypes } from "reducers/products";

export const types = {
    LIST_DEPOSITS_REQUEST: "deposits/LIST_DEPOSITS_REQUEST",
    LIST_DEPOSITS_SUCCESS: "deposits/LIST_DEPOSITS_SUCCESS",

    DEPOSIT_READ: "deposits/DEPOSIT_READ",
    DEPOSIT_READ_SUCCESS: "deposits/DEPOSIT_READ_SUCCESS",

    LIST_DEPOSITS_RATES_REQUEST: "deposits/LIST_DEPOSITS_RATES_REQUEST",
    LIST_DEPOSITS_RATES_SUCCESS: "deposits/LIST_DEPOSITS_RATES_SUCCESS",
    LIST_DEPOSITS_FAILURE: "deposits/LIST_DEPOSITS_FAILURE",

    NEW_DEPOSIT_SIMULATION_REQUEST: "deposits/NEW_DEPOSIT_SIMULATION_REQUEST",
    NEW_DEPOSIT_SIMULATION_SUCCESS: "deposits/NEW_DEPOSIT_SIMULATION_SUCCESS",
    NEW_DEPOSIT_SIMULATION_FAILURE: "deposits/NEW_DEPOSIT_SIMULATION_FAILURE",

    SET_NEW_DEPOSIT_FORM_VALUES: "deposits/SET_NEW_DEPOSIT_FORM_VALUES",
    DEPOSIT_TICKET_CREDENTIAL_REQUEST: "deposits/DEPOSIT_TICKET_CREDENTIAL_REQUEST",
    DEPOSIT_TICKET_CREDENTIAL_SUCCESS: "deposits/DEPOSIT_TICKET_CREDENTIAL_SUCCESS",
    NEW_DEPOSIT_FORM_VALUES_SHOW: "deposits/NEW_DEPOSIT_FORM_VALUES_SHOW",
    NEW_DEPOSIT_TICKET_REQUEST: "deposits/NEW_DEPOSIT_TICKET_REQUEST",
    NEW_DEPOSIT_TICKET_SUCCESS: "deposits/NEW_DEPOSIT_TICKET_SUCCESS",
    NEW_DEPOSIT_TICKET_ERROR: "deposits/NEW_DEPOSIT_TICKET_ERROR",
    SET_NEW_DEPOSIT_SIGNING: "deposits/SET_NEW_DEPOSIT_SIGNING",
    CLEAN_NEW_DEPOSIT_DATA: "deposits/CLEAN_NEW_DEPOSIT_DATA",
    CLEAN_NEW_DEPOSIT_TICKET: "deposits/CLEAN_NEW_DEPOSIT_TICKET",
    SIGN_DEPOSIT_TICKET_REQUEST: "deposits/SIGN_DEPOSIT_TICKET_REQUEST",
    SIGN_DEPOSIT_TICKET_SUCCESS: "deposits/SIGN_DEPOSIT_TICKET_SUCCESS",
    CANCEL_AUTORENEWAL_REQUEST: "deposits/CANCEL_AUTORENEWAL_REQUEST",
    CANCEL_AUTORENEWAL_SUCCESS: "deposits/CANCEL_AUTORENEWAL_SUCCESS",

    TOGGLE_OPTIONS: "deposits/TOGGLE_OPTIONS",
    SET_DEPOSITS_TO_HISTORICAL: "deposits/SET_DEPOSITS_TO_HISTORICAL",

    LIST_HISTORICAL_DEPOSITS_REQUEST: "deposits/LIST_HISTORICAL_DEPOSITS_REQUEST",
    LIST_HISTORICAL_DEPOSITS_SUCCESS: "deposits/LIST_HISTORICAL_DEPOSITS_SUCCESS",
    LIST_HISTORICAL_DEPOSITS_FAILURE: "deposits/LIST_HISTORICAL_DEPOSITS_FAILURE",
    CLEAN_HISTORICAL_DEPOSITS: "deposits/CLEAN_HISTORICAL_DEPOSITS",
    CLEAN_SELECTED_DEPOSIT: "deposits/CLEAN_SELECTED_DEPOSIT",

    DOWNLOAD_DEPOSIT_LIST_REQUEST: "deposits/DOWNLOAD_DEPOSIT_LIST_REQUEST",
    DOWNLOAD_DEPOSIT_LIST_SUCCESS: "deposits/DOWNLOAD_DEPOSIT_LIST_SUCCESS",
    DOWNLOAD_DEPOSIT_LIST_FAILURE: "deposits/DOWNLOAD_DEPOSIT_LIST_FAILURE",

    DOWNLOAD_DEPOSIT_REQUEST: "deposits/DOWNLOAD_DEPOSIT_REQUEST",
    DOWNLOAD_DEPOSIT_SUCCESS: "deposits/DOWNLOAD_DEPOSIT_SUCCESS",
    DOWNLOAD_DEPOSIT_FAILURE: "deposits/DOWNLOAD_DEPOSIT_FAILURE",

    HISTORIC_DEPOSIT_READ: "deposits/HISTORIC_DEPOSIT_READ",
    SUCCESS: "deposits/LIST_DEPOSITS_SUCCESS",
    SET_DEPOSIT_DATA: "deposits/SET_DEPOSIT_DATA",
    SET_DEPOSIT_TAB: "deposits/SET_DEPOSIT_TAB",

    CLEAR_DEPOSIT_DATA: "deposits/CLEAR_DEPOSIT_DATA",

    CREATE_DEPOSIT_ACCEPT_TERM: "deposits/CREATE_DEPOSIT_ACCEPT_TERM",
    CREATE_DEPOSIT_ACCEPT_TERM_SUCCESS: "deposits/CREATE_DEPOSIT_ACCEPT_TERM_SUCCESS",
    CREATE_DEPOSIT_ACCEPT_TERM_FAILURE: "deposits/CREATE_DEPOSIT_ACCEPT_TERM_FAILURE",
};

export const INITIAL_STATE = {
    deposits: [],
    depositsRates: [],
    noDepositFound: false,
    historicalDeposits: [],
    totalInvested: null,
    totalInvestedUSD: null,
    fetching: false,
    historicalDepositsFetching: false,
    idSelectedDeposit: null,
    selectedDeposit: {},
    newDepositFormValues: {
        depositType: "",
        investCapital: {},
        debitAccount: {
            productType: "",
            number: "",
        },
        termInDays: 30,
        expirationAction: "",
    },
    newDepositFormShouldShowLastValues: false,
    newDepositData: {
        earnedInterests: 0,
        chargeAmount: 0,
        termInDays: 0,
        tna: 0,
        expirationDate: new Date(),
        deadline: 0,
        profit: 0,
        stamp: 0,
        jurisdiction: "",
    },
    depositToken: "",
    idSimulationTransaction: "",
    depositRequiredCredentials: [],
    depositTicket: { status: "", idTransaction: "" },
    depositTicketSignable: true,
    filters: {
        account: null,
        creationDateFrom: null,
        creationDateTo: null,
        depositType: null,
        dueDateFrom: null,
        dueDateTo: null,
    },
    toggleOptions: [],
    depositsScreenToHistorical: false,
    depositData: {},
    depositSelectedTab: true,
    fetchingSimulation: false,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        deposits,
        rates,
        totalInvested,
        totalInvestedUSD,
        newDepositFormValues,
        newDepositFormShouldShowLastValues,
        newDepositData,
        depositToken,
        idSimulationTransaction,
        depositRequiredCredentials,
        depositTicket,
        depositTicketSignable,
        toggleOptions,
        depositsScreenToHistorical,
        alias,
        depositData,
        depositSelectedTab,
    } = action;

    switch (action.type) {
        case productsTypes.CHANGE_PRODUCT_ALIAS_SUCCESS: {
            return {
                ...state,
                selectedDeposit: {
                    ...state.selectedDeposit,
                    productAlias: alias,
                },
            };
        }

        case types.DEPOSIT_READ: {
            const selectedDeposit = state.deposits.find((item) => item.idProduct === action.idDeposit);
            return {
                ...state,
                selectedDeposit,
                idSelectedDeposit: action.idDeposit,
            };
        }

        case types.HISTORIC_DEPOSIT_READ: {
            const selectedDeposit = state.historicalDeposits.find(
                (item) => Number(item?.depositNumber) === Number(action.idDeposit),
            );
            return {
                ...state,
                selectedDeposit,
                idSelectedDeposit: action.idDeposit,
            };
        }

        case types.LIST_DEPOSITS_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.LIST_DEPOSITS_SUCCESS:
            return {
                ...state,
                deposits,
                noDepositFound: !deposits.length,
                totalInvested,
                totalInvestedUSD,
                fetching: false,
            };

        case types.LIST_DEPOSITS_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.LIST_HISTORICAL_DEPOSITS_REQUEST:
            return {
                ...state,
                historicalDepositsFetching: true,
                filters: action.filters,
            };
        case types.LIST_HISTORICAL_DEPOSITS_SUCCESS:
            return {
                ...state,
                historicalDeposits: deposits,
                historicalDepositsFetching: false,
            };
        case types.LIST_HISTORICAL_DEPOSITS_FAILURE:
            return {
                ...state,
                historicalDepositsFetching: false,
            };
        case types.CLEAN_HISTORICAL_DEPOSITS:
            return {
                ...state,
                ...(state.depositsScreenToHistorical
                    ? {}
                    : {
                          historicalDeposits: [],
                          historicalDepositsFetching: false,
                      }),
                depositsScreenToHistorical: false,
            };
        case types.CLEAN_SELECTED_DEPOSIT:
            return {
                ...state,
                selectedDeposit: {},
            };

        case types.LIST_DEPOSITS_RATES_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.LIST_DEPOSITS_RATES_SUCCESS:
            return {
                ...state,
                depositsRates: rates,
                fetching: false,
            };

        case types.RESET_FILTERS:
            return { ...state, filters: INITIAL_STATE.filters };

        case types.NEW_DEPOSIT_SIMULATION_REQUEST:
            return {
                ...state,
                newDepositFormValues,
                fetchingSimulation: true,
            };
        case types.NEW_DEPOSIT_SIMULATION_SUCCESS:
            return {
                ...state,
                fetchingSimulation: false,
                newDepositData,
                depositToken,
                idSimulationTransaction,
            };
        case types.NEW_DEPOSIT_SIMULATION_FAILURE:
            return {
                ...state,
                fetchingSimulation: false,
            };
        case types.SET_NEW_DEPOSIT_FORM_VALUES:
            return {
                ...state,
                newDepositFormValues,
            };
        case types.DEPOSIT_TICKET_CREDENTIAL_SUCCESS:
            return {
                ...state,
                fetching: false,
                depositRequiredCredentials,
                depositTicket: { status: "", idTransaction: "" },
            };
        case types.NEW_DEPOSIT_FORM_VALUES_SHOW:
            return {
                ...state,
                newDepositFormShouldShowLastValues,
            };
        case types.NEW_DEPOSIT_TICKET_REQUEST:
            return {
                ...state,
                newDepositFormValues: {
                    depositType: "",
                    investCapital: {},
                    debitAccount: {
                        productType: "",
                        number: "",
                    },
                    termInDays: 30,
                    expirationAction: "",
                },
                depositTicket: { status: "", idTransaction: "" },
            };
        case types.NEW_DEPOSIT_TICKET_SUCCESS:
            return {
                ...state,
                depositTicket,
                depositTicketSignable: !(depositTicket.status !== "INVALID_CREDENTIAL"),
            };
        case types.NEW_DEPOSIT_TICKET_ERROR:
            return {
                ...state,
                depositTicket: { status: "LIMIT_ERROR" },
            };
        case types.CLEAN_NEW_DEPOSIT_DATA:
            return {
                ...state,
                newDepositData: {
                    earnedInterests: 0,
                    chargeAmount: 0,
                    termInDays: 0,
                    tna: 0,
                    expirationDate: new Date(),
                },
            };
        case types.CLEAN_NEW_DEPOSIT_TICKET:
            return {
                ...state,
                newDepositFormValues: {
                    depositType: "",
                    investCapital: {},
                    debitAccount: {
                        productType: "",
                        number: "",
                    },
                    termInDays: 30,
                    expirationAction: "",
                },
                depositTicket: { status: "", idTransaction: "" },
                depositTicketSignable: true,
                newDepositFormShouldShowLastValues: false,
            };
        case types.SET_NEW_DEPOSIT_SIGNING:
            return {
                ...state,
                depositTicketSignable,
            };
        case types.SIGN_DEPOSIT_TICKET_REQUEST:
            return {
                ...state,
                depositTicket: { status: "", idTransaction: "" },
            };
        case types.SIGN_DEPOSIT_TICKET_SUCCESS:
            return {
                ...state,
                depositTicket,
            };
        case types.CANCEL_AUTORENEWAL_REQUEST:
            return {
                ...state,
                depositTicket: { status: "", idTransaction: "" },
            };
        case types.CANCEL_AUTORENEWAL_SUCCESS:
            return {
                ...state,
                depositTicket,
            };

        case types.TOGGLE_OPTIONS:
            return {
                ...state,
                toggleOptions,
            };

        case types.DOWNLOAD_DEPOSIT_LIST_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_DEPOSIT_LIST_FAILURE:
        case types.DOWNLOAD_DEPOSIT_LIST_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.SET_DEPOSITS_TO_HISTORICAL:
            return {
                ...state,
                depositsScreenToHistorical,
                ...(depositsScreenToHistorical ? { toggleOptions: [] } : {}),
            };
        case types.DOWNLOAD_DEPOSIT_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_DEPOSIT_FAILURE:
        case types.DOWNLOAD_DEPOSIT_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.SET_DEPOSIT_DATA:
            return {
                ...state,
                depositData,
            };
        case types.SET_DEPOSIT_TAB:
            return {
                ...state,
                depositSelectedTab,
            };
        case types.CLEAR_DEPOSIT_DATA:
            return {
                ...state,
                depositData: {},
            };

        default:
            return state;
    }
};

export const actions = {
    listDeposits: () => ({
        type: types.LIST_DEPOSITS_REQUEST,
    }),
    listHistoricalDeposits: (filters, formikBag, closeSidebar) => ({
        type: types.LIST_HISTORICAL_DEPOSITS_REQUEST,
        filters,
        formikBag,
        closeSidebar,
    }),
    cleanHistoricalDeposits: () => ({
        type: types.CLEAN_HISTORICAL_DEPOSITS,
    }),
    cleanSelectedDeposit: () => ({
        type: types.CLEAN_SELECTED_DEPOSIT,
    }),
    listDepositsRates: (depositType, currency) => ({
        type: types.LIST_DEPOSITS_RATES_REQUEST,
        depositType,
        currency,
    }),
    readDeposit: (idDeposit) => ({
        type: types.DEPOSIT_READ,
        idDeposit,
    }),
    readHistoricDeposit: (idDeposit) => ({
        type: types.HISTORIC_DEPOSIT_READ,
        idDeposit,
    }),
    setNewDepositData: (newDepositData, depositToken) => ({
        type: types.NEW_DEPOSIT_SIMULATION_SUCCESS,
        newDepositData,
        depositToken,
    }),
    setNewDepositFormValues: (newDepositFormValues) => ({
        type: types.SET_NEW_DEPOSIT_FORM_VALUES,
        newDepositFormValues,
    }),
    fetchNewDepositSimulation: (newDepositFormValues) => ({
        type: types.NEW_DEPOSIT_SIMULATION_REQUEST,
        newDepositFormValues,
    }),
    fetchCredentialGroup: () => ({
        type: types.DEPOSIT_TICKET_CREDENTIAL_REQUEST,
    }),
    newDepositFormShouldShowLastValues: (newValue) => ({
        type: types.NEW_DEPOSIT_FORM_VALUES_SHOW,
        newDepositFormShouldShowLastValues: newValue,
    }),
    setDepositCredential: (newDepositData, credentials) => ({
        type: types.NEW_DEPOSIT_TICKET_REQUEST,
        newDepositData,
        credentials,
    }),
    signDepositTransaction: (signParams) => ({
        type: types.SIGN_DEPOSIT_TICKET_REQUEST,
        signParams,
    }),
    cleanNewDepositData: () => ({
        type: types.CLEAN_NEW_DEPOSIT_DATA,
    }),
    cleanDepositTicket: () => ({
        type: types.CLEAN_NEW_DEPOSIT_TICKET,
    }),
    setDepositTicketSignable: (newValue) => ({
        type: types.SET_NEW_DEPOSIT_SIGNING,
        depositTicketSignable: newValue,
    }),
    cancelAutoRenewal: (selectedDeposit, formikBag, credentialType) => ({
        type: types.CANCEL_AUTORENEWAL_REQUEST,
        selectedDeposit,
        formikBag,
        credentialType,
    }),
    toggleOptions: (options) => ({
        type: types.TOGGLE_OPTIONS,
        toggleOptions: options,
    }),
    setDepositsScreenToHistorical: (newValue) => ({
        type: types.SET_DEPOSITS_TO_HISTORICAL,
        depositsScreenToHistorical: newValue,
    }),
    downloadDepositList: (active, filters, format) => ({
        type: types.DOWNLOAD_DEPOSIT_LIST_REQUEST,
        active,
        filters,
        format,
    }),
    downloadDeposit: (deposit, format, active = true) => ({
        type: types.DOWNLOAD_DEPOSIT_REQUEST,
        deposit,
        format,
        active,
    }),
    setDepositData: (depositData) => ({
        type: types.SET_DEPOSIT_DATA,
        depositData,
    }),
    setDepositTab: (depositSelectedTab) => ({
        type: types.SET_DEPOSIT_TAB,
        depositSelectedTab,
    }),
    clearDepositData: () => ({
        type: types.CLEAR_DEPOSIT_DATA,
    }),

    acceptTermDeposit: (idTransaction, category) => ({
        type: types.CREATE_DEPOSIT_ACCEPT_TERM,
        idTransaction,
        category,
    }),
};

export const selectors = {
    getFetching: ({ deposits }) => deposits.fetching,
    getDeposits: ({ deposits }) => deposits.deposits,
    getDepositsRates: ({ deposits }) => deposits.depositsRates,
    getDepositsLength: ({ deposits }) => deposits.deposits.length,
    getNoDepositFound: ({ deposits }) => deposits.noDepositFound,
    getHistoricalDeposits: ({ deposits }) => deposits.historicalDeposits,
    getTotalInvestedCapital: ({ deposits }) => ({
        mainCurrency: deposits.totalInvested,
        USD: deposits.totalInvestedUSD,
    }),
    getHistoricalDepositsFetching: ({ deposits }) => deposits.historicalDepositsFetching,
    getFilters: ({ deposits }) => deposits.filters,
    getSelectedDeposit: ({ deposits }) => deposits.selectedDeposit,
    getNewDepositFormValues: ({ deposits }) => deposits.newDepositFormValues,
    getNewDepositFormShouldShowLastValues: ({ deposits }) => deposits.newDepositFormShouldShowLastValues,
    getNewDepositData: ({ deposits }) => deposits.newDepositData,
    getDepositToken: ({ deposits }) => deposits.depositToken,
    getDepositRequiredCredentials: ({ deposits }) => deposits.depositRequiredCredentials,
    getDepositTicketStatus: ({ deposits }) => deposits.depositTicket?.status,
    getDepositTicketId: ({ deposits }) => deposits.depositTicket?.idTransaction,
    getDepositTicket: ({ deposits }) => deposits.depositTicket,
    getDepositTicketSignable: ({ deposits }) => deposits.depositTicketSignable,
    getToggleOptions: ({ deposits }) => deposits.toggleOptions,
    getDepositsScreenToHistorical: ({ deposits }) => deposits.depositsScreenToHistorical,
    getFetchingDownload: ({ deposits }) => deposits.fetchingDownload,
    getFetchingSimulation: ({ deposits }) => deposits.fetchingSimulation,
    getIdSimulationTransaction: ({ deposits }) => deposits.idSimulationTransaction,
};
